import { fridayAgentInit, fridayAgent, User, Env } from "@cvte/react-fridayagent3";
import { isMac, isMobile } from "../platform";
import { ReportEvent, SPData, DispatchEvents } from "./type";
import { getVersion } from "../getVersion";


const getClientType = () => {
  if (window.LinkService) {
    return "pc";
  }
  if (isMobile()) {
    return "h5";
  }
  return "web";
};

const getOS = () => {
  if (!isMobile()) {
    return isMac() ? "mac" : "windows";
  } else {
    return "";
  }
};

class Friday {
  private agent: fridayAgent | null = null;

  constructor() {
    this.init();
  }

  async init() {
    const appId = process.env.VITE_FRIDAY_APPID || '';
    const version = await getVersion();
    this.agent = fridayAgentInit(appId);
    this.agent.setEnv({
      client_type: getClientType(),
      app_version: version,
      system_type: getOS(),
    });
    this.pushData({
      eventCode: 'HomePage_startboot',
    })
  }

  setUser(user: User) {
    console.log('setUser', user);
    this.agent?.setUser(user);
  }

  setEnv(env?: Env){
    console.log('setEnv', env);
    this.agent?.setEnv(env);
  }

  generateSPDataArr(reportEvents: ReportEvent[]) {
    const spDataArr: SPData[] = [];
    reportEvents.forEach((reportEvent) => {
      const spData: SPData = {
        code: reportEvent.eventCode,
        name: reportEvent.eventName,
        data: reportEvent.payload || {},
      };
      spDataArr.push(spData);
    });
    return spDataArr;
  }

  async pushData(events: DispatchEvents) {
    if (!events) return;

    const eventsType = Object.prototype.toString.apply(events);
    let formatEvents = events as ReportEvent[];
    if (eventsType === "[object Object]") {
      formatEvents = [events as ReportEvent];
    }
    if (!formatEvents) {
      console.error("events type is not correctly", events);
      return;
    }
    const spDataArr = this.generateSPDataArr(formatEvents);
    spDataArr.forEach(spData => {
      this.agent?.pushData(spData)
    })
  }
}
const fridayReporter = new Friday()
export default fridayReporter;
